import vehicles from '../../services/vehicles'
import axios from 'axios'
import messageDialog from '../../components/message-dialog.vue'
import C from '../common/constantes';

export default {
  data() {
    return {
      vehicle: undefined,
      radioSelected: undefined,
      brands: undefined,
      brandSelected: undefined,
      models: undefined,
      otherCategories: otherCategories,
      otherCategorySelected: undefined,
      loading: undefined,
      years: undefined,
      states: states,
      colors: colors,
      classVehicle: {},
      driver: {},
      axesSelected: {},
      updateModel: false,
      modelSelected: undefined
    }
  },

  mounted() {
    let brandPromise = vehicles.getVehicleBrand()
      .then(data => {
        this.brands = data;
        _.each(data, function (obj) {
          obj.value = obj.brandId;
          obj.caption = obj.name;
        });
      });
    let vehiclePromise = vehicles.getVehicleById(this.vehicleId)
      .then(resp => {
        this.vehicle = resp;
        this.brandSelected = this.vehicle.model.brand.brandId;
        this.classVehicle['pull-right'] = this.vehicle.cancelDate == undefined;
        this.classVehicle['pull-left'] = !this.classVehicle['pull-right'];

        this.modelSelected = this.vehicle.model.modelId;

        this.driver = this.vehicle.drivers && this.vehicle.drivers.driver ? this.vehicle.drivers.driver[0] : {vehicleId: this.vehicle.vehicleId};
      });

      Promise.all([brandPromise, vehiclePromise]).then(res => {
        this.loadModels(false).then(res => {
          this.selectRadio();
          this.modelSelected = this.vehicle.model.modelId;
          let vm = this;
          this.$nextTick(() => {
            vm.updateModel = true;
          });
        });

      });



    this.years = this.loadYears();

  },

  computed: {
    vehicleId() {
      return this.$route.params.vehicleId;
    },
    contractId() {
      return this.$route.params.contractId;
    },
    getAxesSelected() {
      if (this.radioSelected > 0)
        return this.radioSelected;

      return this.otherCategorySelected;
    },
    ownFleet: {
      get(){
        return this.vehicle.ownFleet == 'Y';
      },
      set(val){
        
        this.vehicle.ownFleet = val ? 'Y' : 'N';
      }
    },
    axesDescription(){
      if(!this.getAxesSelected)
        return '';

      return _.find(C.Axes, (o) => {
        return o.value == this.getAxesSelected
      }).caption;
    },
    modelDescription(){
      if(!this.modelSelected)
        return '';

      return _.find(this.models, (o) => {
        return o.modelId == this.modelSelected
      }).caption;
    },
    brandDescription(){
    if(!this.brandSelected)
      return '';

      return _.find(this.brands, (o) => {
        return o.brandId == this.brandSelected
      }).caption;
    },
  },
  methods: {

    loadModels() {
      return vehicles.getVehicleModel(this.brandSelected)
        .then(data => {
          this.models = data;
          _.each(data, function (obj) {
            obj.value = obj.modelId;
            obj.caption = obj.name;
          });
          if(this.updateModel)
            this.modelSelected = data[0].modelId;
          return data;
        });
    },
    onModelSelected(item) {
      if(!item)
        return;
      this.axesSelected = item.category.categoryId;
      
    },
    loadYears() {
      let years = [];
      let yerCurrent = new Date().getFullYear();
      for (let i = 0; i < 30; i++) {
        years.push({
          value: (yerCurrent - i),
          caption: (yerCurrent - i)
        });
      }
      return years;
    },
    doUpdate() {
      
      this.$validator.validateAll().then(s => {
        this.vehicle.categoryAxes.categoryAxesId = this.getAxesSelected;
        this.vehicle.categoryAxes.name = this.axesDescription;
        this.vehicle.model.modelId = this.modelSelected;
        this.vehicle.model.name = this.modelDescription;
        this.vehicle.model.brand.brandId = this.brandSelected;
        this.vehicle.model.brand.name = this.brandDescription;

        if(!this.vehicle.rntrc || this.vehicle.rntrc.trim() == ""){
          this.vehicle.ownFleet = 'Y';
        }

        if(this.vehicle.ownFleet == 'N'){
          this.vehicle.drivers = {driver: [this.driver]};
        }

        this.loading = vehicles.updateVehicle({
            vehicle: this.vehicle
          })
          .then(resp => {
            messageDialog.show({
              title: 'Sucesso',
              message: 'Veículo atualizado com sucesso',
              headerClass: 'modal-success'
            })
          })
          .catch(err => {
            messageDialog.show({
              title: 'Erro',
              message: err.data.status.message,
              headerClass: 'modal-danger'
            });
          });
      }).catch(err => {
        
        messageDialog.show({
          title: 'Erro',
          message: 'Por favor, verifique os campos em vermelho',
          headerClass: 'modal-danger'
        });
      });

    },
    selectRadio() {
      let axesId = this.vehicle.categoryAxes.categoryAxesId;
      this.axesSelected = this.vehicle.model.category.categoryId;
      if (_.find(otherCategories, (o) => o.value == axesId)) {
        this.otherCategorySelected = this.vehicle.categoryAxes.categoryAxesId;
        this.radioSelected = -1;
      } else {
        this.radioSelected = this.vehicle.categoryAxes.categoryAxesId;
      }

    }


  }

}
const colors = [{
    caption: "Branco",
    value: "Branco"
  },
  {
    caption: "Preto",
    value: "Preto"
  },
  {
    caption: "Vermelho",
    value: "Vermelho"
  },
  {
    caption: "Prata",
    value: "Prata"
  },
  {
    caption: "Cinza",
    value: "Cinza"
  },
  {
    caption: "Azul",
    value: "Azul"
  },
  {
    caption: "Marrom/Bege",
    value: "Marrom/Bege"
  },
  {
    caption: "Verde",
    value: "Verde"
  },
  {
    caption: "Amarelo/Dourado",
    value: "Amarelo/Dourado"
  },
  {
    caption: "Outras",
    value: "Outras"
  },

];
const states = [{
    caption: "Acre - AC",
    value: "AC"
  },
  {
    caption: "Alagoas - AL",
    value: "AL"
  },
  {
    caption: "Amapá - AP",
    value: "AP"
  },
  {
    caption: "Amazonas - AM",
    value: "AM"
  },
  {
    caption: "Bahia - BA",
    value: "BA"
  },
  {
    caption: "Ceará - CE",
    value: "CE"
  },
  {
    caption: "Distrito Federal - DF",
    value: "DF"
  },
  {
    caption: "Espírito Santo - ES",
    value: "ES"
  },
  {
    caption: "Goiás - GO",
    value: "GO"
  },
  {
    caption: "Maranhão - MA",
    value: "MA"
  },
  {
    caption: "Mato Grosso - MT",
    value: "MT"
  },
  {
    caption: "Mato Grosso do Sul - MS",
    value: "MS"
  },
  {
    caption: "Minas Gerais - MG",
    value: "MG"
  },
  {
    caption: "Paraná - PR",
    value: "PR"
  },
  {
    caption: "Paraíba - PB",
    value: "PB"
  },
  {
    caption: "Pará - PA",
    value: "PA"
  },
  {
    caption: "Pernambuco - PE",
    value: "PE"
  },
  {
    caption: "Piauí - PI",
    value: "PI"
  },
  {
    caption: "Rio de Janeiro - RJ",
    value: "RJ"
  },
  {
    caption: "Rio Grande do Norte - RN",
    value: "RN"
  },
  {
    caption: "Rio Grande do Sul - RS",
    value: "RS"
  },
  {
    caption: "Rondônia - RO",
    value: "RO"
  },
  {
    caption: "Roraima - RR",
    value: "RR"
  },
  {
    caption: "Santa Catarina - SC",
    value: "SC"
  },
  {
    caption: "Sergipe - SE",
    value: "SE"
  },
  {
    caption: "São Paulo - SP",
    value: "SP"
  },
  {
    caption: "Tocantins - TO",
    value: "TO"
  }
];
const otherCategories = [{
    value: 12,
    caption: "10 eixos, rodagem dupla"
  },
  {
    value: 13,
    caption: "11 eixos, rodagem dupla"
  },
  {
    value: 14,
    caption: "12 eixos, rodagem dupla"
  },
  {
    value: 15,
    caption: "13 eixos, rodagem dupla"
  },
  {
    value: 16,
    caption: "14 eixos, rodagem dupla"
  },
  {
    value: 17,
    caption: "15 eixos, rodagem dupla"
  },
  {
    value: 18,
    caption: "16 eixos, rodagem dupla"
  },
  {
    value: 19,
    caption: "17 eixos, rodagem dupla"
  },
  {
    value: 20,
    caption: "18 eixos, rodagem dupla"
  },
  {
    value: 21,
    caption: "19 eixos, rodagem dupla"
  },
  {
    value: 22,
    caption: "20 eixos, rodagem dupla"
  },
  {
    value: 23,
    caption: "21 eixos, rodagem dupla"
  },
  {
    value: 24,
    caption: "22 eixos, rodagem dupla"
  },
  {
    value: 25,
    caption: "23 eixos, rodagem dupla"
  },
  {
    value: 26,
    caption: "24 eixos, rodagem dupla"
  },
  {
    value: 27,
    caption: "25 eixos, rodagem dupla"
  },
  {
    value: 28,
    caption: "26 eixos, rodagem dupla"
  },
  {
    value: 29,
    caption: "27 eixos, rodagem dupla"
  },
  {
    value: 30,
    caption: "28 eixos, rodagem dupla"
  },
  {
    value: 31,
    caption: "29 eixos, rodagem dupla"
  },
  {
    value: 32,
    caption: "30 eixos, rodagem dupla"
  },
  {
    value: 33,
    caption: "31 eixos, rodagem dupla"
  },
  {
    value: 34,
    caption: "32 eixos, rodagem dupla"
  },
  {
    value: 35,
    caption: "33 eixos, rodagem dupla"
  },
  {
    value: 36,
    caption: "34 eixos, rodagem dupla"
  },
  {
    value: 37,
    caption: "35 eixos, rodagem dupla"
  },
  {
    value: 38,
    caption: "36 eixos, rodagem dupla"
  },
  {
    value: 39,
    caption: "37 eixos, rodagem dupla"
  },
  {
    value: 40,
    caption: "38 eixos, rodagem dupla"
  },
  {
    value: 41,
    caption: "39 eixos, rodagem dupla"
  },
  {
    value: 42,
    caption: "40 eixos, rodagem dupla"
  },
  {
    value: 43,
    caption: "41 eixos, rodagem dupla"
  },
  {
    value: 44,
    caption: "42 eixos, rodagem dupla"
  },
  {
    value: 45,
    caption: "43 eixos, rodagem dupla"
  },
  {
    value: 46,
    caption: "44 eixos, rodagem dupla"
  },
  {
    value: 47,
    caption: "45 eixos, rodagem dupla"
  },
  {
    value: 48,
    caption: "46 eixos, rodagem dupla"
  },
  {
    value: 49,
    caption: "47 eixos, rodagem dupla"
  },
  {
    value: 50,
    caption: "48 eixos, rodagem dupla"
  }
];



// WEBPACK FOOTER //
// ./src/pages/account/vehicle-edit.js